import React from 'react';
import {
  IconButton,
  InputAdornment,
  TextField,
} from '@mui/material';
import {
  HandleNumbericInput,
  HandleNumericKeyDown,
} from 'utils/NumericInputHandler';
import classes from 'Global/Styles/PersianSupport.module.scss';
import { Price3DigitSplitter } from 'utils/Price3DigitSplitter';

const EditablePersianSupportNumericTextField = ({
  label,
  onChange,
  errors,
  name,
  icon,
  iconFn,
  callbackFn,
  value,
  variant,
  isEnglish = true,
  disabled,
  isSmall = true,
  customOnChange = () => {},
  enableSeperator = false,
  isOctalAllowed,
}) => {
  const [UiValue, setUiValue] = React.useState(value);

  React.useEffect(() => {
    if (
      value !== undefined &&
      value !== null &&
      value?.toString()?.length > 0
    ) {
      const event = {
        target: {
          value,
        },
      };
      setUiValue(
        HandleNumbericInput(event, isOctalAllowed)
      );
      onChange && onChange(Number(value));
    }
  }, [value, isOctalAllowed]);

  return (
    <React.Fragment>
      <TextField
        {...(isSmall && { size: 'small' })}
        disabled={disabled}
        variant={variant ?? 'outlined'}
        value={
          enableSeperator
            ? Price3DigitSplitter(UiValue)
            : UiValue
        }
        color="colorPrimer"
        dir={!isEnglish ? 'rtl' : 'ltr'}
        label={label}
        onChange={(event) => {
          onChange &&
            onChange(
              HandleNumbericInput(event, isOctalAllowed)
            );
          setUiValue(
            HandleNumbericInput(event, isOctalAllowed)
          );
          customOnChange && customOnChange(event);
        }}
        onKeyDown={(event) => HandleNumericKeyDown(event)}
        fullWidth
        InputLabelProps={
          !isEnglish
            ? {
                classes: {
                  root: classes.textFieldroot,
                  shrink: classes.textFieldShrink,
                },
              }
            : {}
        }
        FormHelperTextProps={{
          sx: {
            textAlign: 'right',
          },
        }}
        InputProps={
          icon
            ? {
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      color="colorPrimer"
                      onClick={() =>
                        iconFn(
                          UiValue,
                          onChange,
                          callbackFn
                        )
                      }
                    >
                      {icon}
                    </IconButton>
                  </InputAdornment>
                ),
              }
            : {
                endAdornment: <></>,
                inputProps: { inputMode: 'numeric' },
              }
        }
        error={!!errors?.[name] ?? false}
        helperText={
          errors?.[name] ? `فیلد ${label} را پرکنید` : ''
        }
        sx={{ minHeight: '40px' }}
      />
    </React.Fragment>
  );
};

export default EditablePersianSupportNumericTextField;
